/* eslint-disable react/jsx-no-undef */
import './styles.css';
import './search.css';
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import routes from './routes'; // Import the routes

// Import page components
import Home from './pages/home';
import AllResults from './pages/allResults';
import About from './pages/about';
import Writing from './pages/writing';
import Works from './pages/works';
import Social from './pages/social';
import ProjectsPage from './pages/projectsPage';
import ImagesPage from './pages/imagesPage';
import BlogPage from './pages/blogPage';
import NotFound from './pages/notFound';
import ProductLinkedin from './pages/productLinkedin';
import ProductMapScraper from './pages/productMapScraper';
import ProductLegalAgent from './pages/productLegalAgent';
import ProductRealEstateAgent from './pages/productRealEstate';
import ProductSalesAgent from './pages/productSalesAgent';
import InvestAgent from './pages/investAgent';
import HrAgent from './pages/productHrAgent';
import ProductShoppingAgent from './pages/productShoppingAgent';
import ProductShopifyAgent from './pages/productShopifyAgent';

// Map component names to actual React components
const componentMap = {
  Home,
  AllResults,
  About,
  Writing,
  Works,
  Social,
  ProjectsPage,
  ImagesPage,
  BlogPage,
  ProductLinkedin,
  ProductMapScraper,
  ProductLegalAgent,
  InvestAgent,
  HrAgent,
  ProductRealEstateAgent,
  ProductSalesAgent,
  ProductShoppingAgent,
  ProductShopifyAgent,
};

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          {routes.map((route) => (
            <Route
              key={route.path}
              exact={route.path === '/'}
              path={route.path}
              component={componentMap[route.component]}
            />
          ))}
          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }
}

export default App;
